module.exports = __webpack_public_path__ + "img/184.6b54562b.jpg";